// Wraps the app in the MUI theme for the current light / dark mode so MUI
// surfaces (Paper, Dialog, Menu, TextField, DataGrid, date pickers) follow the
// site theme. Light mode is MUI's default theme, unchanged from before; dark
// mode uses the mytabs.app navy palette from theme.css.

import React, { useMemo } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import useTheme from "./useTheme";
import "./theme.css";

const lightTheme = createTheme();

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    // Deeper cyan with white text: many buttons override only the background
    // (indigo, orange, ...) and rely on MUI's white button text, as in light.
    primary: { main: "#0097a7", light: "#00bcd4", contrastText: "#ffffff" },
    secondary: { main: "#ff6b9d" },
    background: { default: "#0a0e27", paper: "#141a3a" },
    text: {
      primary: "#f4f5f8",
      secondary: "rgba(244, 245, 248, 0.72)",
      disabled: "rgba(244, 245, 248, 0.45)",
    },
    divider: "rgba(244, 245, 248, 0.12)",
  },
  components: {
    // Drop MUI's elevation overlay so every panel is the same navy.
    MuiPaper: { styleOverrides: { root: { backgroundImage: "none" } } },
  },
});

export function muiThemeFor(mode) {
  return mode === "dark" ? darkTheme : lightTheme;
}

export default function AppThemeProvider({ children }) {
  const { theme } = useTheme();
  const muiTheme = useMemo(() => muiThemeFor(theme), [theme]);
  return <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>;
}
